import React from 'react';
import { useDispatch } from 'react-redux';
import { AppBar, Toolbar, Hidden, Grid, Container } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import SearchBox from '../SearchBox/SearchBox';
import Drawer from '../Drawer/Drawer';
import AppLogo from '../AppLogo/AppLogo';
import CurrentLocation from '../CurrentLocation/CurrentLocation';
import PoweredByLauktiLogo from '../../assets/logos/powered_by_laukti_logo.svg';
import { setSearchQuery } from '../../redux/modules/search';
import { isKickCovidDomain } from '../../common/helpers';
import useStyles from './Navbar.styles';

const Navbar = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const redirectToHomeHandler = () => {
    dispatch(setSearchQuery(''));
    history.push('/home');
  };

  const getToolbarContent = () => {
    if (props.showMenuButtonOnly) {
      return (
        <Grid container direction="row-reverse">
          <Grid className={classes.drawerContainer} item>
            <Drawer />
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Grid container direction="row" justify="space-between" alignItems="flex-start">
          <Grid item sm={1}>
            <div className={classes.logoContainer} onClick={redirectToHomeHandler}>
              <AppLogo navbar />
            </div>
          </Grid>
          <Grid item md={7} lg={6}>
            <Grid container direction="column" spacing={1}>
              <Grid item>
                <SearchBox showHints={false} />
              </Grid>
              <Grid item>
                <Grid container direction="row" justify="space-between">
                  <Grid className={classes.locationContainer} item>
                    <CurrentLocation />
                  </Grid>
                  {isKickCovidDomain() ? (
                    <Grid item>
                      <img className={classes.poweredByLogo} src={PoweredByLauktiLogo} alt="Powered By Laukti"></img>
                    </Grid>
                  ) : (
                    <Grid item>{null}</Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Drawer />
          </Grid>
        </Grid>
      );
    }
  };

  return (
    <div className={classes.root}>
      <Hidden smDown>
        <AppBar className={classes.navbar} position="sticky" elevation={0}>
          <Toolbar>
            <Container>{getToolbarContent()}</Container>
          </Toolbar>
        </AppBar>
      </Hidden>
      <Hidden mdUp>
        <Container className={classes.navbar}>
          {props.showMenuButtonOnly ? (
            <Grid container direction="row-reverse">
              <Grid className={classes.drawerContainer} item>
                <Drawer />
              </Grid>
            </Grid>
          ) : (
            <div>
              <Grid container direction="row">
                <Grid item>
                  <div className={classes.logoContainer} onClick={redirectToHomeHandler}>
                    <AppLogo navbar />
                  </div>
                </Grid>
              </Grid>
              <Grid container direction="row-reverse">
                <Grid item>
                  <Drawer />
                </Grid>
              </Grid>
              <Grid className={classes.searchBoxContainerDownSm} container direction="row">
                <Grid item xs={12}>
                  <SearchBox showHints={false} />
                </Grid>
              </Grid>
              <Grid container direction="row" justify="space-between" alignItems="center">
                <Grid className={classes.locationContainer} item>
                  <CurrentLocation />
                </Grid>
                {isKickCovidDomain() ? (
                  <Grid item>
                    <img className={classes.poweredByLogo} src={PoweredByLauktiLogo} alt="Powered By Laukti"></img>
                  </Grid>
                ) : null}
              </Grid>
            </div>
          )}
        </Container>
      </Hidden>
    </div>
  );
};

Navbar.propTypes = {
  showMenuButtonOnly: PropTypes.bool
};

export default Navbar;
